import React from 'react';
import { useRequestActivitiesQueryContext } from 'src/features/requests/request-activity/use-request-activities-query-context';
import RequestActivityEntry, {
  RequestActivityEntrySkeleton,
} from 'src/features/requests/request-activity/request-activity-entry';
import { NoRecordsFallback } from 'src/features/fallback/ui/no-records-fallback';
import { Button } from 'src/components/ui/button';
import { RequestActivityTermsAcceptance } from 'src/features/requests/request-activity/request-activity-terms-acceptance';

const RequestActivityListContent: React.FC = () => {
  const { data, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useRequestActivitiesQueryContext();

  const activities = data?.pages.flatMap((page) => page.items) ?? [];
  const hasActivities = activities.length > 0;
  const firstPageMeta = data?.pages[0]?.meta;

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <RequestActivityTermsAcceptance
        signUp={firstPageMeta?.terms_acceptance}
        payment={firstPageMeta?.payment_terms_acceptance}
      />
      {hasActivities ? (
        <>
          {activities.map((activity) => (
            <RequestActivityEntry key={activity.id} activity={activity} />
          ))}
          {isFetchingNextPage &&
            Array.from({ length: 3 }).map((_, index) => (
              <RequestActivityEntrySkeleton key={`loading-${index}`} />
            ))}
          {hasNextPage && !isFetchingNextPage && (
            <Button
              variant="outline"
              className="tw-self-center"
              onClick={() => fetchNextPage()}
            >
              Load more
            </Button>
          )}
        </>
      ) : (
        <NoRecordsFallback />
      )}
    </div>
  );
};

const RequestActivityListContentSkeleton: React.FC = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {Array.from({ length: 5 }).map((_, index) => (
        <RequestActivityEntrySkeleton key={index} />
      ))}
    </div>
  );
};

export { RequestActivityListContentSkeleton };
export default RequestActivityListContent;
